var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCaretRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1939 6.59172C10.8671 6.14651 10.9631 5.52066 11.4083 5.19384C11.8535 4.86703 12.4794 4.96301 12.8062 5.40822L20.3164 15.5376C20.6106 15.9383 20.6536 16.194 20.3164 16.5376L12.8062 26.7313C12.4794 27.1765 11.8535 27.2725 11.4083 26.9457C10.9631 26.6189 10.8671 25.993 11.1939 25.5478L18.1515 16.0698L11.1939 6.59172Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCaretRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/caret-right.de0c02b39b04df81a6c1bec7c7ee380a.svg";